import axios from 'axios';

const api = axios.create({
    baseURL: 'https://10thftic.nerdetcetera.com/api',
})

export default api;